import { useTranslation } from "react-i18next";
import { useDeleteLexiconConcept } from "@noa/api-client";
import type { LexiconConceptResponse } from "@noa/api-core";
import { Dialog, Text } from "~/components/ui";
import { lexiconModalClassNames } from "~/utils/lexicon";

type DeleteConceptModalProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  concept: LexiconConceptResponse | null;
};

export function DeleteConceptModal({ isOpen, setIsOpen, concept }: DeleteConceptModalProps) {
  const { t } = useTranslation("lexicon");
  const { mutate: deleteLexicalConcept, isPending: isDeletingLexicalConcept } = useDeleteLexiconConcept();

  const handleConfirm = () => {
    if (!concept) return;

    deleteLexicalConcept(
      { unique: concept.unique, subject_en: concept.subject_en, subject_fr: concept.subject_fr },
      {
        onSuccess: () => setIsOpen(false),
      }
    );
  };

  return (
    <Dialog
      title={t("deleteConceptModal.title")}
      open={isOpen}
      onOk={handleConfirm}
      onCancel={() => setIsOpen(false)}
      okText={t("actions.delete")}
      okButtonProps={{ danger: true }}
      cancelText={t("common:cancel")}
      confirmLoading={isDeletingLexicalConcept}
      classNames={lexiconModalClassNames}
    >
      <Text>
        {t("deleteConceptModal.bodyPrefix")} <Text strong>{concept?.term_fr}</Text> ?
      </Text>
    </Dialog>
  );
}
